import React from 'react';
import { Link } from 'react-router-dom';
import { FaMicrochip, FaWrench, FaBullhorn, FaArrowRight } from 'react-icons/fa';
import './Ourcompanysection.css';

// Update this path to point at your real photo asset.
// Recommended size: at least 1200x900px, landscape, well-lit.
import teamPhoto from  '../img/aaaservices/auto.png';

const SEGMENTS = [
  { icon: FaMicrochip, label: 'IT Engineering' },
  { icon: FaWrench, label: 'Mechanical' },
  { icon: FaBullhorn, label: 'Digital' },
];

/**
 * "Our Company" overview section — photo + stat badge on one side,
 * heading / copy / segment cards / CTA on the other.
 * Stacks to a single column on small screens; every size from 320px
 * to 4K is covered in OurCompanySection.css.
 */
const OurCompanySection = () => {
  return (
    <section className="company-section" aria-labelledby="company-heading">
      <div className="company-container">
        {/* ---------------------------------------------------------- */}
        {/* Photo + floating stat card                                 */}
        {/* ---------------------------------------------------------- */}
        <div className="company-media">
          <div className="company-image-frame">
            <img
              src={teamPhoto}
              alt="Two engineers collaborating at their desks"
              className="company-image"
              loading="lazy"
            />
          </div>

          <div className="company-stat-card">
            <span className="company-stat-number">15+</span>
            <span className="company-stat-label">Years of Impact</span>
          </div>
        </div>

        {/* ---------------------------------------------------------- */}
        {/* Copy + segment cards + CTA                                 */}
        {/* ---------------------------------------------------------- */}
        <div className="company-content">
          <p className="company-eyebrow">Our Company</p>

          <h2 id="company-heading" className="company-heading">
            Engineering and technology across{' '}
            <span className="company-heading-accent">three segments</span>
          </h2>

          <p className="company-description">
            Our engineering and technology services are divided across three
            segments to cover practically every industry. Deep specialization,
            coupled with an unparalleled ability to innovate across
            industries, allows our clients to go further, faster.
          </p>

          <div className="company-segments">
            {SEGMENTS.map(({ icon: Icon, label }) => (
              <div className="segment-card" key={label}>
                <span className="segment-icon" aria-hidden="true">
                  <Icon />
                </span>
                <span className="segment-label">{label}</span>
              </div>
            ))}
          </div>

          <Link to="/who-we-are" className="company-cta">
            <span>About Envision</span>
            <FaArrowRight aria-hidden="true" className="company-cta-icon" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default OurCompanySection;